'use strict';

(function() {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};

  window.atex.aceui.Content = function() {
    return {
      system: {},
      aspects: {}
    }
  };
})();
